<ng-container *ngIf="formComplete">
    <div class="alert alert-success" role="alert">We have received your enquiry. We will contact you soon.</div>
</ng-container>
<ng-container *ngIf="!formComplete">
    <form (ngSubmit)="onSubmit()" [formGroup]="formGroup">
        <div class="row">
            <div class="col-12 col-md-6 mb-3">
                <label class="form-label">Name</label>
                <input class="form-control" formControlName="name" type="text" />
            </div>

            <div class="col-12 col-md-6 mb-3">
                <label class="form-label">Email Address</label>
                <input class="form-control" formControlName="email" type="email" />
            </div>

            <div class="col-12 col-md-6 mb-3">
                <label class="form-label">Phone</label>
                <input class="form-control" formControlName="phone" type="text" />
            </div>

            <div class="col-12 col-md-6 mb-3">
                <label class="form-label">How many parking bays?</label>
                <input class="form-control" formControlName="bays" type="text" />
            </div>
        </div>

        <div class="mb-3">
            <label class="form-label">City / Location</label>
            <input class="form-control" formControlName="location" type="text" />
        </div>

        <div class="mb-3">
            <label class="form-label">Any additional information</label>
            <textarea class="form-control" formControlName="detail" rows="5" type="text"></textarea>
        </div>

        <ng-container *ngIf="formError">
            <div class="alert alert-danger pa-3" role="alert">
                <pre>{{ formError }}</pre>
            </div>
        </ng-container>

        <ng-container [ngTemplateOutlet]="formLoading ? formInvalidTemplate : validTemplate"></ng-container>
        <ng-template #formSubmittingTemplate>
            <button class="btn btn-primary" disabled type="submit">
                <span aria-hidden="true" class="spinner-border spinner-border-sm" role="status"></span>
                Loading...
            </button>
        </ng-template>
        <ng-template #formInvalidTemplate>
            <button class="btn btn-primary" disabled type="submit">Submit</button>
        </ng-template>
        <ng-template #validTemplate>
            <button class="btn btn-primary" type="submit">Submit</button>
        </ng-template>
    </form>
</ng-container>
